module.exports = {
      id: "comm-album-usage",
      viewBox: "0 0 230.223 54.026",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#comm-album",
      toString: function () {
        return this.url;
      }
    }